import { css } from '@emotion/react'
import {
  Theme,
  Color,
  Size,
  Spacing,
  deriveAccessibleColors,
  CornerRadius,
  ThemedColors,
  LineWeight,
} from '@opallabs/gem'

export const radioGroup = css({
  columnGap: Spacing.S,
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  maxHeight: 312,
  overflowY: 'auto',
  padding: Spacing.XS / 2,
})

export const radioItem = ({
  theme,
  selected,
}: {
  theme: Theme
  selected: boolean
}) =>
  css({
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: CornerRadius.Medium,
    minBlockSize: 28,
    padding: Spacing.XS / 2,
    position: 'relative',

    '&:focus, &:hover': {
      backgroundColor: Color[theme].Surface.N000,
      // Override an existing boxShadow: none that has !important
      boxShadow: selected
        ? 'none'
        : `0 0 0 2px ${Color[theme].Surface.A100} !important`,
      cursor: 'pointer',
      outline: 'none',
    },
  })

export const indicator = (theme: Theme) =>
  css({
    border: `solid 2px ${Color[theme].Surface.A200}`,
    borderRadius: Size.Rounding * 2,
    blockSize: Spacing.M * 2,
    insetInlineStart: -(Spacing.XS - 2),
    position: 'absolute',
    insetBlockStart: -(Spacing.XS / 2),
    inlineSize: Spacing.M * 2,
  })

export const colorSwatch = ({
  color,
  size = 24,
}: {
  color: string
  size?: number
}) =>
  css({
    backgroundColor: color,
    borderColor: color
      ? deriveAccessibleColors(color).border
      : `var(${ThemedColors.StrokeSecondary3})`,
    borderStyle: 'solid',
    borderWidth: LineWeight.Small,
    borderRadius: CornerRadius.Small,
    blockSize: size,
    inlineSize: size,
  })
